'use strict';

require('isomorphic-fetch');

require('leaflet-routing-machine');

var _map = require('./map.js');

var _map2 = _interopRequireDefault(_map);

var _mapifyMap = require('./mapify-map.js');

var _mapifyMap2 = _interopRequireDefault(_mapifyMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = jQuery;
var $document = $(document);
var $window = $(window);
var Promise = require('bluebird');

$document.ready(function () {
	$('.prettyroutes-map').each(function () {
		var $this = $(this);
		var settings = JSON.parse($this.attr('data-json'));
		var map = new _map2.default($this, settings);
	});
});

$('body').on('mapify.map.created', function (event, map) {
	var mapifyMap = new _mapifyMap2.default(map);
});


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/index.js
// module id = 16
// module chunks = 0